module.exports = exports = window.fetch;
exports.Headers = window.Headers;
exports.Request = window.Request;
exports.Response = window.Response;



//////////////////
// WEBPACK FOOTER
// ./node_modules/node-fetch/browser.js
// module id = 369
// module chunks = 0